import service from '@/utils/request'
import store, { baseAPI, baseUrl } from '../store'


const apiConst = {
  // 官方直播间相关接口
  official_room_list: baseAPI + baseUrl + 'config/room_program/official_room_query',
  official_room_create: baseAPI + baseUrl + 'config/room_program/create_official_room',
  official_room_update: baseAPI + baseUrl + 'config/room_program/update_official_room',
  official_program_list: baseAPI + baseUrl + 'config/room_program/program_query',
  official_program_create: baseAPI + baseUrl + 'config/room_program/program_create',
  official_program_delete: baseAPI + baseUrl + 'config/room_program/program_del',
}

// 官方直播间查询
export const getOfficialRoomList = async (query) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.official_room_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...query
    }
  })
  return res
}

// 官方直播间创建
export const createOfficialRoom = async (query) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.official_room_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...query
    }
  })
  return res
}

// 官方直播间修改
export const updateOfficialRoomList = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.official_room_update,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}

// 官方直播间节目单查询
export const getOfficialProgramRoomList = async (query) => {
  const { data: res } = await service({
    method: 'get',
    url: apiConst.official_program_list,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
      ...query
    }
  })
  return res
}

// 官方直播间节目单创建
export const createOfficialProgramRoom = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.official_program_create,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token,
    },
    data
  })
  return res
}

// 官方直播间节目单删除
export const deleteOfficialProgramList = async (data) => {
  const { data: res } = await service({
    method: 'post',
    url: apiConst.official_program_delete,
    withCredentials: true,
    params: {
      username: store.getters.username,
      token: store.getters.token
    },
    data
  })
  return res
}



